import { render } from "./VText.vue?vue&type=template&id=13c2dab4&ts=true"
import script from "./VText.vue?vue&type=script&lang=ts"
export * from "./VText.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__